import { ConsolidationRenderResult } from "@/models/consolidation";

export type ConsolidationSnapshot = {
  processedHtml: string;
  result: ConsolidationRenderResult;
};

/**
 * Picks the carry-forward snapshot for a NOT_FOUND changelaw node: the most
 * recent successful render at or before the target's timeline position. This
 * guarantees a pending earlier node never borrows newer consolidated text from a
 * later node that happened to be viewed first. Returns undefined when nothing at
 * or before the target has succeeded (caller then falls back to silver).
 */
export const selectNearestEarlierSnapshot = (
  snapshotsByTimelineIndex: ReadonlyMap<number, ConsolidationSnapshot> | undefined,
  targetTimelineIndex: number | undefined
): ConsolidationSnapshot | undefined => {
  if (!snapshotsByTimelineIndex || targetTimelineIndex === undefined) {
    return undefined;
  }

  let best: ConsolidationSnapshot | undefined;
  let bestIndex = Number.NEGATIVE_INFINITY;
  for (const [index, snapshot] of snapshotsByTimelineIndex) {
    if (index <= targetTimelineIndex && index > bestIndex) {
      bestIndex = index;
      best = snapshot;
    }
  }
  return best;
};
